import { render, staticRenderFns } from "./SupplyObject.vue?vue&type=template&id=0ab3c22a&scoped=true"
import script from "./SupplyObject.vue?vue&type=script&lang=js"
export * from "./SupplyObject.vue?vue&type=script&lang=js"
import style0 from "./SupplyObject.vue?vue&type=style&index=0&id=0ab3c22a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab3c22a",
  null
  
)

export default component.exports